import gql from 'graphql-tag'
import { connect } from 'react-redux'
import { compose, withState } from 'recompose'
import { selectors as OrganizationSelectors } from 'data/organizations'
import { dataFetched, makesQueries } from 'data/graphql'
import { paymentInfosFragment } from '../Billing/dataSync/fragments'

const organizationPaymentInfosQuery = gql`
  query organizationPaymentInfos($organizationId: ID!) {
    showOrganization(id: $organizationId) {
      __typename
      id
      usersCount
      activeUsersCount
      paymentInfos {
        ...paymentInfosAttrs
      }
    }
  }
  ${paymentInfosFragment}
`

const providesOrganizationPaymentInfos = compose(
  withState('paymentInfoFetchState', 'setFetchState', {
    loading: false,
    error: false,
    pristine: true,
  }),
  connect(
    state => ({
      organizationId: OrganizationSelectors.getOrganizationId(state),
    }),
    { dataFetched }
  ),
  makesQueries({
    query: organizationPaymentInfosQuery,
    mapPropsToVariables: ({ organizationId }) => ({ organizationId }),
    getOnQueryFromProps: ({ setFetchState }) => () =>
      setFetchState({ loading: true, error: null, pristine: false }),
    getOnResultFromProps: ({ dataFetched, setFetchState }) => ({
      result,
      meta,
    }) => {
      dataFetched(result.data.showOrganization, meta)
      setFetchState({ loading: false, error: null })
    },
    getOnErrorFromProps({ setError, setFetchState }) {
      return ({ error }) => {
        setFetchState({ loading: false, error })
      }
    },
  })
)

export default providesOrganizationPaymentInfos
